import { ILedger } from './interfaces'
import { autoserializeAs } from 'cerialize'

export type LedgerType = 'rev'|'exp'

export default class Ledger implements ILedger {

  @autoserializeAs('id')
  public id: string = ''

  @autoserializeAs('type')
  public type: 'rev'|'exp' = 'rev'

  @autoserializeAs('name')
  public name: string = ''

  @autoserializeAs('unit')
  public unit: number = 0

  @autoserializeAs('per_unit')
  public perUnit: number = 0

  @autoserializeAs('vat_percent')
  public vatPercent: number = 0

  @autoserializeAs('issue_date')
  public issueDate: Date = new Date()

  public get totalVat(): number {
    const portion = +this.vatPercent
    return this.total * (portion / (100.0 + portion))
  }

  public get total(): number {
    return +(+this.unit * +this.perUnit).toFixed(2)
  }

  constructor(type: LedgerType) {
    this.type = type
  }
}
